// extracted by mini-css-extract-plugin
export var actionButton = "_kp-t";
export var buttonContainer = "_kp-0";
export var buttonContainer2 = "_kp-1";
export var buttonSection = "_kp-2";
export var details = "_kp-3";
export var dropdownItem = "_kp-5";
export var dropdownItemsContainer = "_kp-4";
export var fileInput = "_kp-r";
export var headerButton = "_kp-6";
export var icon = "_kp-7";
export var input = "_kp-8";
export var macroListItem = "_kp-9";
export var mainContent = "_kp-a";
export var microText = "_kp-b";
export var modal = "_kp-w";
export var optionsButton = "_kp-c";
export var paperclip = "_kp-s";
export var pillContent = "_kp-d";
export var preview = "_kp-e";
export var preview2 = "_kp-f";
export var quillEditor = "_kp-q";
export var selectedMacro = "_kp-g";
export var sidebar = "_kp-h";
export var sidebarHeader = "_kp-j";
export var sidebarList = "_kp-i";
export var sidebarListItem = "_kp-k";
export var sidebarSearch = "_kp-l";
export var snoozeDurationWrapper = "_kp-v";
export var statusPillContainer = "_kp-m";
export var tagsContainer = "_kp-n";
export var unselectedMacro = "_kp-o";
export var variable = "_kp-u";
export var wrapper = "_kp-p";